module.exports = __webpack_public_path__ + "0ea36aec89d8585b509956af24682559.png";